module.exports = __webpack_public_path__ + "img/support_bg.c69daf58.jpg";